import _ from 'underscore';
import React from 'react';
import { SeasonalityAdjustmentCreationPanel } from './creation-form/seasonality-adjustment-creation-form';
import { pairsToMap } from './pairs-to-map';


export function getToolbarConfig({
  showTopOfGridPanel,
  lazyInject,
  i18n,
  adjustmentType,
}) {
  function withSelectedId(actionName) {
    return () => {
      const {
        toolbarAction,
        backboneGridView,
      } = lazyInject();

      const selectedItems = backboneGridView.grid.gridView.selectedItems();
      const seasonalityIds = _.pluck(selectedItems, 'Id');

      toolbarAction[actionName](seasonalityIds[0]);
    };
  }

  const toolbarSelectedConfig = pairsToMap([
    ['button-edit', {
      id: 'button-edit',
      type: 'dropdown',
      classes: ['btn-primary'],
      iconLeftGlyphName: 'ba-Edit',
      text: i18n.getString(_TL_('Edit')),
      menu: {
        items: [
          {
            id: 'button-delete',
            type: 'button',
            classes: ['seasonality-toolbar-delete-button'],
            iconLeftGlyphName: 'ba-Delete',
            text: i18n.getString(_TL_('Delete')),
            onClick: withSelectedId('onDeleteSeasonality'),
          },
          {
            type: 'dropdown-divider',
          },
          {
            id: 'button-update',
            type: 'button',
            classes: ['seasonality-toolbar-change-settings-button'],
            text: i18n.getString(_TL_('Change settings')),
            onClick: withSelectedId('onEditSeasonality'),
          },
        ],
      },
    }],
    ['expander', {
      type: 'expander',
    }],
    ['button-clear-selection', {
      id: 'button-clear-selection',
      type: 'button-clear-selection',
    }],
  ]);

  const toolbarUnselectedConfig = pairsToMap([
    ['button-seasonality-adjustment-create', {
      id: 'button-seasonality-adjustment-create',
      text: i18n.getString(_TL_('Create')),
      type: 'button',
      classes: ['btn-primary'],
      iconLeftGlyphName: 'ba-Add',
      noResponsive: true,
      onClick: () => {
        const creationView = (
          <SeasonalityAdjustmentCreationPanel
            adjustmentType={adjustmentType}
            onSuccess={() => {
              showTopOfGridPanel(null);
              lazyInject().reloadGrid();
            }}
            onCancel={() => {
              showTopOfGridPanel(null);
            }}
          />
        );
        showTopOfGridPanel(creationView);
      },
    }],
    ['predicate-list', {
      id: 'predicate-list',
      type: 'custom',
    }],
    ['search-box-filter', {
      id: 'search-box-filter',
      type: 'search-box',
    }],
    ['dropdown-column-chooser', {
      id: 'dropdown-column-chooser',
      type: 'dropdown',
    }],
  ]);

  return {
    toolbarSelectedConfig,
    toolbarUnselectedConfig,
  };
}

